var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", {
    id: "barcode_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5C21.0544 5 21.9182 5.81588 21.9945 6.85074L22 7V17C22 18.0544 21.1841 18.9182 20.1493 18.9945L20 19H4C2.94564 19 2.08183 18.1841 2.00549 17.1493L2 17V7C2 5.94564 2.81588 5.08183 3.85074 5.00549L4 5H20ZM6 8C5.44772 8 5 8.44772 5 9V15C5 15.5523 5.44772 16 6 16C6.55228 16 7 15.5523 7 15V9C7 8.44772 6.55228 8 6 8ZM12 8C11.4477 8 11 8.44772 11 9C11 8.44772 10.5523 8 10 8C9.48717 8 9.06449 8.38604 9.00673 8.88338L9 9V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15C11 15.5523 11.4477 16 12 16C12.5128 16 12.9355 15.614 12.9933 15.1166L13 15V9C13 8.44772 12.5523 8 12 8ZM15 8C14.4872 8 14.0645 8.38604 14.0067 8.88338L14 9V15C14 15.5523 14.4477 16 15 16C15.5128 16 15.9355 15.614 15.9933 15.1166L16 15V9C16 8.44772 15.5523 8 15 8ZM18 8C17.4477 8 17 8.44772 17 9V15C17 15.5523 17.4477 16 18 16C18.5523 16 19 15.5523 19 15V9C19 8.44772 18.5523 8 18 8Z",
    fill: "#15803D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scan_icon.6542e34bb22049e8c2c9e60002dd6f53.svg";
export { ForwardRef as ReactComponent };